'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _CamNighttime = require('./CamNighttime');

var _CamNighttime2 = _interopRequireDefault(_CamNighttime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CamNighttime2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CamNighttime/index.js
// module id = 536
// module chunks = 11